import React from 'react';

const ErrorMessage = () => <div>Er is iets mis gegaan</div>;

export default ErrorMessage;
